import { useRef, useState, useEffect } from 'react';
import SingleBtn from 'components/common/elements/SingleBtn';
import SignatureCanvas from 'react-signature-canvas';
import { STYLES_VARIABLES } from 'constants/styleVariables';
import styles from 'styles/pages/modal/SignaturePad.module.scss';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { ReactComponent as ResetIcon } from 'assets/icons/reset.svg';
import { ReactComponent as SignIcon } from 'assets/icons/pencil_sign.svg';
import useModal from 'hooks/useModal';

type TProps = {
  imgURL?: string | null;
  onSigned?: (imgURL: string) => void;
};

const SignaturePad = ({ imgURL, onSigned }: TProps) => {
  const { closeModal } = useModal();
  const canvasRef = useRef<any>(null);
  const [isSigned, setIsSigned] = useState(false);

  useEffect(() => {
    if (imgURL && canvasRef.current) {
      canvasRef.current.fromDataURL(imgURL);
      setIsSigned(true);
    }
  }, [imgURL]);

  const onClickReset = () => {
    canvasRef.current.clear();
    setIsSigned(false);
  };

  const onClickClose = () => {
    closeModal();
    onSigned && onSigned('');
  };

  const onClickSave = () => {
    closeModal();
    onSigned &&
      onSigned(isSigned ? canvasRef.current.toDataURL('image/png') : '');
  };

  return (
    <div>
      <div className="dimmed"></div>
      <div className={styles.pad_wrapper}>
        <div className="flex justify_between">
          <h1 className={styles.title}>동의서 서명</h1>
          <button type="button" onClick={onClickClose}>
            <CloseIcon alt="close" fill={STYLES_VARIABLES.GRAY_07} />
          </button>
        </div>
        <div className="relative">
          <SignatureCanvas
            ref={canvasRef}
            onBegin={() => {
              setIsSigned(true);
            }}
            canvasProps={{
              width: 512,
              height: 146,
              className: 'canvas',
            }}
          />
          {!isSigned && (
            <div className={styles.placeholder_wrapper}>
              <SignIcon width={56} height={56} />
              <p style={{ color: STYLES_VARIABLES.GRAY_06 }}>
                동의서를 위한 서명을 해주세요.
              </p>
            </div>
          )}
          <button className={styles.reset_wrapper} onClick={onClickReset}>
            <ResetIcon
              width={12}
              height={12}
              fill={STYLES_VARIABLES.PURPLE_01}
            />
            <p className="fs12 fw700">초기화</p>
          </button>
        </div>
        <div className="modal_btn_wrapper mt24">
          <SingleBtn
            btnText="취소"
            hasOutline={true}
            btnStyle={{
              width: '100%',
            }}
            onClick={onClickClose}
          />
          <SingleBtn
            btnText="확인"
            isBtnActive={true}
            btnStyle={{
              width: '100%',
            }}
            disabled={!isSigned && !imgURL}
            onClick={onClickSave}
          />
        </div>
      </div>
    </div>
  );
};

export default SignaturePad;
